import axios from "../../configs/axios-instances";
import dashboardPath from "../../constants/dashboard-path.constant";
import eventOrganizerPathConstants from "../../constants/organizer/event-org-path.contant";
const upcomingEventDashboardApi = {
  getAllUpcomingEventsList: ({ params, success, error }) => {
    const {
      upcomingEvents: { getUpcomingEvent },
    } = dashboardPath;
    const {
      page,
      limit,
      location,
      category,
      event,
      dates,
      id,
      is_trending,
      is_recommended,
      currency,
    } = params;
    let pathWithParams = getUpcomingEvent;

    const queryParams = [];
    if (id) queryParams.push(`id=${id}`);
    if (page) queryParams.push(`page=${page}`);
    if (limit) queryParams.push(`limit=${limit}`);
    if (location) queryParams.push(`location=${location}`);
    if (category) queryParams.push(`category=${encodeURIComponent(category)}`);
    if (event) queryParams.push(`event=${event}`);
    if (dates) queryParams.push(`dates=${dates}`);
    if (is_trending) queryParams.push(`is_trending=${is_trending}`);
    if (is_recommended) queryParams.push(`is_recommended=${is_recommended}`);
    if (currency) queryParams.push(`currency=${currency}`);
    if (queryParams.length > 0) {
      pathWithParams += `?${queryParams.join("&")}`;
    }

    axios.getRequest({
      path: pathWithParams,
      error,
      success,
    });
  },

  getEventCategories: ({ success, error }) => {
    const {
      upcomingEvents: { getEventCategories },
    } = dashboardPath;
    axios.getRequest({
      path: getEventCategories,
      success,
      error,
    });
  },

  getEventContentById: ({ item_id, currency, success, error }) => {
    const {
      upcomingEvents: { getEventContentById },
    } = dashboardPath;
    axios.getRequest({
      path: `${getEventContentById}?event_id=${item_id}&currency=${currency}`,
      success,
      error,
    });
  },

  getEventOrganizerById: ({ id, success, error }) => {
    const {
      upcomingEvents: { getEventOrganizerById },
    } = dashboardPath;
    axios.getRequest({
      path: `${getEventOrganizerById}?organizer_id=${id}`,
      success,
      error,
    });
  },

  getEventTicketList: ({ event_id, currency, success, error }) => {
    const {
      EventTickets: { ticketList },
    } = eventOrganizerPathConstants;

    axios.getRequest({
      path: `${ticketList}?event_id=${event_id}&currency=${currency}`,
      success,
      error,
    });
  },

  getEventTicketListForSeats: ({ event_id, currency,success, error }) => {
    const {
      EventTickets: { ticketListForSeats },
    } = eventOrganizerPathConstants;

    axios.getRequest({
      path: `${ticketListForSeats}?event_id=${event_id}&currency=${currency}`,
      success,
      error,
    });
  },
  getEventFomoMessages: ({ eventId, config, success, error }) => {
    const {
      eventManage: { fomoMessages },
    } = eventOrganizerPathConstants;
    axios.getRequest({
      config,
      path: `${fomoMessages}?eventId=${eventId}`,
      success,
      error,
    });
  },
};

export default upcomingEventDashboardApi;
